module.exports = __webpack_public_path__ + "static/media/Kricketune_gaussian2.41532058.png";